import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CategorymasterService } from 'src/app/core/services/categorymaster.service';
import { profileService } from 'src/app/core/services/profile.service';
@Component({
  selector: 'app-create-account-placed',
  templateUrl: './account_created.component.html',
  styleUrls: ['./account_created.component.scss']
})
export class AccountCreated implements OnInit {
  
  // Data passed from parent

  constructor(public modalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private profileservice: profileService,
    private categorymasterService: CategorymasterService,
    public bsCreateModalRef: BsModalRef,
    private router: Router,
    
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.modalRef.hide();
    window.location.reload();
    this.router.navigate(['/dashboard']);
  }


}